import React, { useEffect, useState } from 'react';
import { Input } from '@cokitchen/cokitchen-components';
import useMealContext from 'contexts/meal.context';
import { isEditMeal } from 'utils/functions';
import { useLocation } from 'react-router-dom';
import { BrandOption } from 'utils/types';
import SelectBrand from 'components/select-brand';
import Select from 'components/base/select';
import NewCategoryModal from 'components/new-category-modal';

const MealBrandDetails = () => {
  const {
    formData,
    setFormData,
    categoryList,
    setCategoryList,
    selectedBrand,
    setSelectedBrand,
    selectedCategoryList,
    setSelectedCategoryList,
    setDisabled,
    selectedBaseMeal,
    setAllBrands
  } = useMealContext();
  const [isChecked, setIsChecked] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    const selectedCategoryIds = selectedCategoryList.map((category) => category.value);
    setFormData({ ...formData, meal_category_id: selectedCategoryIds });
  }, [selectedCategoryList]);

  useEffect(() => {
    const selectedCategoryIds = selectedCategoryList.map((category) => category.value);
    const selectedBaseMealIds = selectedBaseMeal.map((meal) => meal.value);
    setFormData({
      ...formData,
      meal_category_id: selectedCategoryIds,
      base_meal_id: selectedBaseMealIds,
      brand_id: selectedBrand ? selectedBrand.map((brand) => brand.value) : []
    });
  }, [selectedCategoryList, selectedBrand, selectedBaseMeal]);

  useEffect(() => {
    if (formData.brand_id && formData.meal_category_id.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [formData]);

  const handleCloseCategoryModal = (newCategoryItems?: BrandOption[]) => {
    setIsChecked(false);
    if (newCategoryItems) {
      setCategoryList([...newCategoryItems, ...categoryList]);
      setSelectedCategoryList([...selectedCategoryList, ...newCategoryItems]);
    }
  };

  return (
    <>
      <div>
        <div className='mb-6'>
          <p className='text-sm font-medium mb-2'>What brand should this meal be added to?</p>

          <SelectBrand
            hasSearch
            brands={selectedBrand ? selectedBrand : []}
            returnAllBrands={(brands) => setAllBrands(brands)}
            setBrands={setSelectedBrand}
            disabled={isEditMeal(pathname)}
          />
        </div>
        {selectedBrand && (
          <div>
            <p className='text-sm font-medium mb-2'>Select meal category</p>
            <Select
              hasSearch
              placeholder='Select category'
              value={selectedCategoryList.map((c) => c.value)?.[0]}
              options={categoryList}
              onChange={(v) => setSelectedCategoryList(categoryList.filter((c) => c.value === v))}
            />
          </div>
        )}

        <div className='mt-8 bg-[#F9F6F6] rounded-md border-[0.5px] border-[#EEECEC] px-[20px] py-3'>
          <Input
            type='checkbox'
            className='mr-2'
            label='Add new meal category'
            checked={isChecked}
            onChange={() => {
              setIsChecked(!isChecked);
            }}
          />
        </div>

        <NewCategoryModal
          isOpen={isChecked}
          onClose={handleCloseCategoryModal}
          selectedBrand={selectedBrand ? selectedBrand : []}
          setSelectedBrand={setSelectedBrand}
        />
      </div>
    </>
  );
};

export default MealBrandDetails;
